enum HeaderThemeEnum {
  WHITE = 'white',
  COLORFUL = 'colorful'
}

export type HeaderThemeType = HeaderThemeEnum.WHITE | HeaderThemeEnum.COLORFUL;

export { HeaderThemeEnum };
